import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { vReveal } from './directives/reveal';
import { loadUmami } from './analytics/umami';
import '@fontsource-variable/bricolage-grotesque/opsz.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import './assets/styles/main.css';

const app  = createApp(App).use(router);
app.directive('reveal', vReveal);

app.mount('#app');
loadUmami();